import { getAuth, signInWithCustomToken } from 'firebase/auth'
import { handleAuthToken } from '~/utils/handleAuthToken'

const fetchCustomToken = async (token: string) => {
  const { $api: api } = useNuxtApp()
  const navigationStore = useNavigationStore()
  const response = await api.auth.surveyLogin(token)
  if (!response.customToken) throw new Error('Fetched custom token not found.')
  const auth = await getAuth()
  const firebaseResponse = await signInWithCustomToken(auth, response.customToken)
  navigationStore.setExternalContext()
  const currentToken = await firebaseResponse.user.getIdToken()
  const userStore = useUserStore()
  api.setToken(currentToken)
  userStore.save(firebaseResponse.user, currentToken, 'token')
  userStore.saveFromToken(currentToken)
}

export default defineNuxtRouteMiddleware(async (to, from) => {
  const authToken = to.query?.authToken as string
  const token = to.query?.token as string

  if (['mobile', 'VideoCallExternal', 'reset-password'].includes(to.name as string)) return

  if (authToken) {
    return await handleAuthToken(authToken)
  } else if (token) {
    return await fetchCustomToken(token)
  }
})
